import { FilterableInterface } from './filterable.interface';
import { Refrigeration } from './refrigeration';

export class RefrigerationGroup implements FilterableInterface {
  constructor(
    public hash?: string,
    public name?: string,
    public refrigerations?: Refrigeration[]
  ) { }

  clone() {
    return new RefrigerationGroup(
      this.hash,
      this.name,
      this.refrigerations
    );
  }

  get filterableData() {
    return `${ this.name }`.toLowerCase();
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/refrigeration-group.ts